import { render, staticRenderFns } from "./ANZDOWNLOAD.vue?vue&type=template&id=5b46dac8"
import script from "./ANZDOWNLOAD.vue?vue&type=script&lang=js"
export * from "./ANZDOWNLOAD.vue?vue&type=script&lang=js"
import style0 from "./ANZDOWNLOAD.vue?vue&type=style&index=0&id=5b46dac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports